import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy
} from '@angular/core';
import {
  ParticipantsBehaviourList
} from "../../../../../../models/participants-behaviour-list";
import {MatTableDataSource} from "@angular/material/table";
import {Subject, takeUntil} from "rxjs";
import {CommonService} from "../../../../../shared/services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {Sort} from "@angular/material/sort";
import {
  sortOrderMap,
  userStatusMap
} from "../../../../../shared/constants/common.constants";
import {
  AdminGroupListService
} from "../../../services/admin-group-list.service";
import {
  configId,
  participantsBehaviourList
} from "../../../core/admin-groups-list.selectors";
import {
  FetchParticipantsBehaviourListRequest
} from "../../../core/admin-groups-list.actions";
import {ActivatedRoute, Router} from "@angular/router";
import {
  ParticipantAndCaregiver
} from '../../../../../../models/participantAndCaregiver';
import {drillDownUrls} from '../../../../../shared/core/shared.selectors';
import {SetDrillDownUrls} from '../../../../../shared/core/shared.actions';


@Component({
  selector: 'app-participant-behaviour-information-table',
  templateUrl: './participant-behaviour-information-table.component.html',
  styleUrls: ['./participant-behaviour-information-table.component.css']
})
export class ParticipantBehaviourInformationTableComponent implements AfterViewInit,
                                                                      OnDestroy {
  @Input() loading: boolean = false;
  @Input() noDataMessage = "No Data Available";
  isFirstPage = true;
  selectedConfigId: number = 1;
  participantBehaviourTableConfig = {
    1: [
      {
        type: 'string',
        key: 'name',
        displayName: 'Name',
      },
      {
        type: 'number',
        key: 'rl_weekly_journal_entry_count',
        displayName: 'Past week days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'rl_eaten_vs_goal',
        displayName: 'Past week red light foods eaten/goal',
        bodyTextAlign: 'center'
      },
      {
        type: 'number',
        key: 'rl_total_days_journaled',
        displayName: 'Total days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'rl_goal_met_vs_set',
        displayName: 'Total no. of red light foods goals met/set',
        bodyTextAlign: 'center'
      }
    ],
    2: [
      {
        type: 'string',
        key: 'name',
        displayName: 'Name',
      },
      {
        type: 'number',
        key: 'pa_weekly_journal_entry_count',
        displayName: 'Past week days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'pa_done_vs_goal',
        displayName: 'Past week physical activity goal',
        bodyTextAlign: 'center'
      },
      {
        type: 'number',
        key: 'pa_total_days_journaled',
        displayName: 'Total days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'pa_goal_met_vs_set',
        displayName: 'Total no. of physical activity goals met/set',
        bodyTextAlign: 'center'
      }
    ],
    3: [
      {
        type: 'string',
        key: 'name',
        displayName: 'Name',
      },
      {
        type: 'number',
        key: 'st_weekly_journal_entry_count',
        displayName: 'Past week days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'st_used_vs_goal',
        displayName: 'Past week screen time used/goal',
        bodyTextAlign: 'center'
      },
      {
        type: 'number',
        key: 'st_total_days_journaled',
        displayName: 'Total days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'st_goal_met_vs_set',
        displayName: 'Total no. of screen time goals met/set',
        bodyTextAlign: 'center'
      }
    ]

  }
  config = [];
  participantBehaviourList: ParticipantsBehaviourList;
  tableData: any[];
  dataSource: any = new MatTableDataSource();
  displayedColumns: any;
  sortOrder: any = 1;
  sortColumn: any = 'name'
  clientId: any;
  isDrillDown: boolean = false;
  private participantBehaviourFilters: {
    clientId?: number,
    groupId?: number,
    role?: number[],
    session?: number,
    status?: number[],
    searchText?: string,
  } = null;
  private readonly OnDestroy: Subject<any> = new Subject<any>();

  constructor(
    private cdref: ChangeDetectorRef,
    private adminGroupListService: AdminGroupListService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private store: Store<fromRoot.State>,
    private router: Router
  ) {
    const params: any = this.route.snapshot.params;
    this.clientId = params?.clientAdminId;
    this.isDrillDown = !!(params && params['clientAdminId']);

    this.store.select(participantsBehaviourList)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.loading = data.loading;
        this.participantBehaviourList = data;


        if (!data.loading) {
          this.dataSource.data = [...data.list];

          if (data.hasNext) {
            setTimeout(() => {
              if (this.sortColumn && data.pageNumber === 1) {
                this.commonService.scrollColumnInView(this.sortColumn);
              }
            }, 0)

            setTimeout(() => {
              // check window height for infinite scroll
              this.commonService.checkInfiniteScrollHeightAndCallNext('table-wrapper', () => {
                this.onScroll();
              });
            }, 0);
          }
        }
      });

    this.store.select(configId)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.selectedConfigId = data;
        this.config = this.participantBehaviourTableConfig[data];
        this.displayedColumns = this.config?.map((eachObject) => eachObject.key);
        this.dataSource.data = [];
        this.fetchParticipantBehaviourInformation();
      });

    // listen for filter changes from the filter component
    this.adminGroupListService.onParticipantBehaviourInformationFilterChange
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((filters) => {
        this.participantBehaviourFilters = filters;

        this.isFirstPage = true;
        if (this.participantBehaviourFilters &&
            this.participantBehaviourFilters.groupId) {
          this.dataSource.data = [];
          this.fetchParticipantBehaviourInformation();
        }
      })
  }

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.tableData);
    this.displayedColumns = this.config.map((eachObject) => eachObject.key);
    this.cdref.detectChanges();
  }

  sortData(sort: Sort) {
    this.isFirstPage = true;
    this.sortColumn = `${sort.active}`;
    this.sortOrder = sortOrderMap[sort.direction];
    this.fetchParticipantBehaviourInformation();
  }

  onScroll() {
    if (this.participantBehaviourList?.hasNext && !this.participantBehaviourList?.loading) {
      this.fetchParticipantBehaviourInformation(this.participantBehaviourList.pageNumber + 1, this.participantBehaviourList.limit);
      this.isFirstPage = false;
    }
  }

  fetchParticipantBehaviourInformation(pageNumber = 1, limit = 10) {
    const payload = {
      ...this.participantBehaviourFilters,
      recordType: this.selectedConfigId,
      pageNumber,
      limit,
      ...(this.sortOrder ? {sortOrder: this.sortOrder} : {}),
      ...(this.sortOrder ? {sortColumn: this.sortColumn} : {}),
    }
    if (this.selectedConfigId && payload.groupId) {
      this.store.dispatch(FetchParticipantsBehaviourListRequest({payload}));
    }
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

  openUserDetails(user: ParticipantAndCaregiver) {
    if (user?.id) {
      this.store.select(drillDownUrls).subscribe(data => {
        const updatedDrillDownUrls = [...data, this.router.url];
        if ([...data].pop() !== this.router.url) {
          this.store.dispatch(SetDrillDownUrls({payload: updatedDrillDownUrls}));
        }
      }).unsubscribe();
      const urlPrefix = this.router.url.split('/')[1];
      this.router.navigate([`/${urlPrefix}/member/${user.id}/behavior-tracker`]);
    }
  }

  protected readonly userStatusMap = userStatusMap;
}
